import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { appConfig } from './app.config';
import { LocalStorage } from './resolvers/local-storage';

const browserConfig: ApplicationConfig = {
  providers: [{ provide: LocalStorage, useValue: window.localStorage }],
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
